import {
  Box,
  Button,
  CircularProgress,
  Typography,
  useMediaQuery
} from "@mui/material";
import { Wrapper } from "./styles";
import DocsContent from "../DocsContent/DocsContent";
import { ImageCustom } from "../../../../components";
import EmptyProject from "../../../../assets/images/common/empty_project.svg";

import { useApi } from "../../../../hooks/useApi.hook";
import { IDocument } from "../../../../models/docs";
import DocsService from "../../../../services/api/docs.service";
import { useEffect, useState } from "react";
import moment from "moment";
import { DATETIME_FORMAT2 } from "../../../../config/constants";
import { CircleRounded, KeyboardArrowDownRounded } from "@mui/icons-material";
import { IBasePaging } from "../../../../models/common/models.type";
import SearchInput from "../../../Member/components/SearchInput";
import { theme } from "../../../../theme/theme";
import { useTranslation } from "react-i18next";

type Props = {};

const DocsUserView = (props: Props) => {
  const [data, setData] = useState<IDocument[]>([]);
  const [inputValue, setInputValue] = useState<string | undefined>();
  const [selectedId, setSelectedId] = useState<string | null>(null);

  const [paging, setPaging] = useState<IBasePaging | null>(null);

  const getPage = useApi<IDocument[]>({ isFetch: true, isPaging: true });
  const getSingle = useApi<IDocument>({ isFetch: true });
  const updateRead = useApi<IDocument>({});
  const [contentView, setContentView] = useState<React.ReactNode | null>(null);
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const { t } = useTranslation();

  function fetchData(pageIdx?: number) {
    getPage.request(
      DocsService.getPageByUser({
        CurrentPage: pageIdx ?? 1,
        PageSize: 10,
        KeySearch: inputValue
      }).then(res => {
        if (res.success) {
          setData(res.currentPage === 1 ? res.items : data.concat(res.items));
          setPaging({
            currentPage: res.currentPage,
            totalPages: res.totalPages,
            pageSize: res.pageSize,
            totalCount: res.totalCount
          });
        }
      })
    );
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Wrapper>
      <div className="left-container">
        <div className="search-container">
          <SearchInput
            fullWidth
            placeholder={t("Docs.SearchPlaceholder")}
            onChange={e => setInputValue(e.target.value)}
            search={() => fetchData()}
          />
        </div>
        <Box className="list-data-container">
          {data.length > 0 &&
            data.map(item => (
              <Box
                key={item.id}
                className="item-card-container"
                style={{
                  backgroundColor: item.isRead ? "white" : "#f1f5f9c5",
                  border:
                    selectedId === item.id ? "2px solid #3091F3" : undefined
                }}
                onClick={() => {
                  if (!item.isRead) {
                    updateRead.request(DocsService.updateRead(item.id));
                  }
                  getSingle.request(
                    DocsService.getSingle(item.id).then(res => {
                      if (res.success) {
                        setSelectedId(res.data.id);
                        setContentView(<DocsContent item={res.data} />);
                      }
                    })
                  );
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between"
                  }}
                >
                  <Typography
                    sx={{
                      color: "white",
                      backgroundColor: "#3091F3",
                      borderRadius: "12px",
                      padding: "1px 8px",
                      fontWeight: 600,
                      fontSize: "10px"
                    }}
                  >
                    {item.documentType?.name}
                  </Typography>
                  <Typography
                    className="item-time"
                    variant="caption"
                    sx={{
                      color: "text.secondary"
                    }}
                  >
                    {moment(item.dateOfIssue).format(DATETIME_FORMAT2)}
                  </Typography>
                </div>
                <Typography
                  className="item-title"
                  variant="caption"
                  component="div"
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: "2",
                    WebkitBoxOrient: "vertical",
                    marginTop: "12px"
                  }}
                >
                  {item.numberIdentifier && `[${item.numberIdentifier}]`}{" "}
                  {item?.title}
                </Typography>
                <Box display="flex">
                  {!item.isRead && selectedId !== item.id && (
                    <Box>
                      <CircleRounded
                        sx={{
                          fontSize: "7px",
                          marginRight: "6px",
                          color: "#3091F3"
                        }}
                      />
                      <Typography
                        variant="caption"
                        fontSize="10px"
                        className="item-time"
                        sx={{
                          color: "text.secondary"
                        }}
                      >
                        {t("Docs.Unread")}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            ))}
          {paging && paging.currentPage !== paging.totalPages && (
            <Box>
              {getPage.loading ? (
                <CircularProgress color="info" />
              ) : (
                <Button
                  color="info"
                  endIcon={<KeyboardArrowDownRounded />}
                  onClick={() => fetchData(paging.currentPage + 1)}
                >
                  {t("Docs.LoadMore")}
                </Button>
              )}
            </Box>
          )}
        </Box>
      </div>
      <div className="right-container">
        <Box className="content-page">
          {contentView ?? (
            <Box className="empty-box">
              <ImageCustom src={EmptyProject} width="auto" height="165px" />
              <Typography variant="subtitle1" marginTop="28px">
                {t("Docs.EmptyTitle")}
              </Typography>
            </Box>
          )}
        </Box>
      </div>
    </Wrapper>
  );
};

export default DocsUserView;
